"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FbIgAutoReplyApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var FbIgAutoReplyApi = /** @class */ (function (_super) {
    __extends(FbIgAutoReplyApi, _super);
    function FbIgAutoReplyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FbIgAutoReplyApi.prototype.fbIgAutoReplyAssignmentRuldIdAutomationActionBlankPost = function (_a, opts) {
        var assignmentRuldId = _a.assignmentRuldId, travisBackendConversationServicesViewModelsFbIgAutoReplyActionBlankViewModel = _a.travisBackendConversationServicesViewModelsFbIgAutoReplyActionBlankViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentRuldId, 'assignmentRuldId', 'fbIgAutoReplyAssignmentRuldIdAutomationActionBlankPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/FbIgAutoReply/{assignmentRuldId}/AutomationAction/Blank'.replace('{assignmentRuldId}', (0, runtime_1.encodeURI)(assignmentRuldId)),
            method: 'POST',
            headers: headers,
            body: travisBackendConversationServicesViewModelsFbIgAutoReplyActionBlankViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyAttachmentUrlFbIgAutoReplyFileIdGet = function (_a, opts) {
        var fbIgAutoReplyFileId = _a.fbIgAutoReplyFileId;
        (0, runtime_1.throwIfNullOrUndefined)(fbIgAutoReplyFileId, 'fbIgAutoReplyFileId', 'fbIgAutoReplyAttachmentUrlFbIgAutoReplyFileIdGet');
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/Attachment/Url/{fbIgAutoReplyFileId}'.replace('{fbIgAutoReplyFileId}', (0, runtime_1.encodeURI)(fbIgAutoReplyFileId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyCompanyFbPagesGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/company/fb/pages',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyCompanyIgPagesGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/company/ig/pages',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyFbPostPageIdPostIdGet = function (_a, opts) {
        var pageId = _a.pageId, postId = _a.postId;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'fbIgAutoReplyFbPostPageIdPostIdGet');
        (0, runtime_1.throwIfNullOrUndefined)(postId, 'postId', 'fbIgAutoReplyFbPostPageIdPostIdGet');
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/FbPost/{pageId}/{postId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)).replace('{postId}', (0, runtime_1.encodeURI)(postId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyFbPostsPageIdGet = function (_a, opts) {
        var pageId = _a.pageId, fromDateTime = _a.fromDateTime, toDateTime = _a.toDateTime, offset = _a.offset, limit = _a.limit, searchKeyword = _a.searchKeyword;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'fbIgAutoReplyFbPostsPageIdGet');
        var headers = {};
        var query = {};
        if (fromDateTime != null) {
            query['fromDateTime'] = fromDateTime;
        }
        if (toDateTime != null) {
            query['toDateTime'] = toDateTime;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (searchKeyword != null) {
            query['searchKeyword'] = searchKeyword;
        }
        return this.request({
            url: '/FbIgAutoReply/FbPosts/{pageId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyGetAttachmentsFbIgAutoReplyIdGet = function (_a, opts) {
        var fbIgAutoReplyId = _a.fbIgAutoReplyId;
        (0, runtime_1.throwIfNullOrUndefined)(fbIgAutoReplyId, 'fbIgAutoReplyId', 'fbIgAutoReplyGetAttachmentsFbIgAutoReplyIdGet');
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/GetAttachments/{fbIgAutoReplyId}'.replace('{fbIgAutoReplyId}', (0, runtime_1.encodeURI)(fbIgAutoReplyId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyIgPostDetailsIgPageIdPostIdGet = function (_a, opts) {
        var igPageId = _a.igPageId, postId = _a.postId;
        (0, runtime_1.throwIfNullOrUndefined)(igPageId, 'igPageId', 'fbIgAutoReplyIgPostDetailsIgPageIdPostIdGet');
        (0, runtime_1.throwIfNullOrUndefined)(postId, 'postId', 'fbIgAutoReplyIgPostDetailsIgPageIdPostIdGet');
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/IgPost/Details/{igPageId}/{postId}'.replace('{igPageId}', (0, runtime_1.encodeURI)(igPageId)).replace('{postId}', (0, runtime_1.encodeURI)(postId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyIgPostsIgPageIdGet = function (_a, opts) {
        var igPageId = _a.igPageId, fromDateTime = _a.fromDateTime, toDateTime = _a.toDateTime, offset = _a.offset, limit = _a.limit, searchKeyword = _a.searchKeyword;
        (0, runtime_1.throwIfNullOrUndefined)(igPageId, 'igPageId', 'fbIgAutoReplyIgPostsIgPageIdGet');
        var headers = {};
        var query = {};
        if (fromDateTime != null) {
            query['fromDateTime'] = fromDateTime;
        }
        if (toDateTime != null) {
            query['toDateTime'] = toDateTime;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (searchKeyword != null) {
            query['searchKeyword'] = searchKeyword;
        }
        return this.request({
            url: '/FbIgAutoReply/IgPosts/{igPageId}'.replace('{igPageId}', (0, runtime_1.encodeURI)(igPageId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyRemoveAttachmentFbIgAutoReplyFileIdDelete = function (_a, opts) {
        var fbIgAutoReplyFileId = _a.fbIgAutoReplyFileId;
        (0, runtime_1.throwIfNullOrUndefined)(fbIgAutoReplyFileId, 'fbIgAutoReplyFileId', 'fbIgAutoReplyRemoveAttachmentFbIgAutoReplyFileIdDelete');
        var headers = {};
        return this.request({
            url: '/FbIgAutoReply/RemoveAttachment/{fbIgAutoReplyFileId}'.replace('{fbIgAutoReplyFileId}', (0, runtime_1.encodeURI)(fbIgAutoReplyFileId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyUpdatePreviewCodeAssignmentIdPut = function (_a, opts) {
        var assignmentId = _a.assignmentId, travisBackendCompanyDomainViewModelsAssignmentRuleViewModel = _a.travisBackendCompanyDomainViewModelsAssignmentRuleViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentId, 'assignmentId', 'fbIgAutoReplyUpdatePreviewCodeAssignmentIdPut');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/FbIgAutoReply/UpdatePreviewCode/{assignmentId}'.replace('{assignmentId}', (0, runtime_1.encodeURI)(assignmentId)),
            method: 'PUT',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAssignmentRuleViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbIgAutoReplyUploadAttachmentPost = function (_a, opts) {
        var messageFormat = _a.messageFormat, fbIgAutoReplyId = _a.fbIgAutoReplyId, file = _a.file;
        var headers = {};
        var formData = new FormData();
        if (messageFormat !== undefined) {
            formData.append('MessageFormat', messageFormat);
        }
        if (fbIgAutoReplyId !== undefined) {
            formData.append('FbIgAutoReplyId', fbIgAutoReplyId);
        }
        if (file !== undefined) {
            formData.append('File', file);
        }
        return this.request({
            url: '/FbIgAutoReply/UploadAttachment',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbigautoreplyRuleHistoryAssignmentIdGet = function (_a, opts) {
        var assignmentId = _a.assignmentId, tab = _a.tab, start = _a.start, end = _a.end, status = _a.status, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentId, 'assignmentId', 'fbigautoreplyRuleHistoryAssignmentIdGet');
        var headers = {};
        var query = {};
        if (tab != null) {
            query['tab'] = tab;
        }
        if (start != null) {
            query['start'] = start;
        }
        if (end != null) {
            query['end'] = end;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/fbigautoreply/rule/history/{assignmentId}'.replace('{assignmentId}', (0, runtime_1.encodeURI)(assignmentId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FbIgAutoReplyApi.prototype.fbigautoreplyRuleStatisticsAssignmentIdGet = function (_a, opts) {
        var assignmentId = _a.assignmentId;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentId, 'assignmentId', 'fbigautoreplyRuleStatisticsAssignmentIdGet');
        var headers = {};
        return this.request({
            url: '/fbigautoreply/rule/statistics/{assignmentId}'.replace('{assignmentId}', (0, runtime_1.encodeURI)(assignmentId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return FbIgAutoReplyApi;
}(runtime_1.BaseAPI));
exports.FbIgAutoReplyApi = FbIgAutoReplyApi;
